/**
 * HTML要素に disabled を付与する
 */
export const disableEventElement = (event) => {
    switchEventElement(event, true);
};
/**
 * HTML要素から disabled を外す
 */
export const enableEventElement = (event) => {
    switchEventElement(event, false);
};
const switchEventElement = (event, disabled) => {
    const disabledClass = "button-disabled";
    const target = event.target;
    if (!("disabled" in target))
        throw new Error("'disabled' is not found in this HTMLElement.");
    disabled ? target.classList.add(disabledClass) : target.classList.remove(disabledClass);
    target.disabled = disabled;
};
